import React from "react";

import { Carousel } from "@mantine/carousel";
import { AspectRatio, Image, SimpleGrid } from "@mantine/core";

export const ImageSelectionCarousel = <T extends { id: string, src: string },>({
	data = [],
	current = null,
	onSelectAvatar = () => null,
}: {
	data: T[];
	current: T | null | undefined;
	onSelectAvatar: (item: { id: string }) => void;
}) => {

	return (
		<Carousel
			height={100}
			slideSize={100}
			slideGap={{ base: "md" }}
			draggable
		>
			{data.map((item, index) => (
				<Carousel.Slide key={index}>
					<AspectRatio ratio={1}>
						<Image
							style={{
								height: "100%",
								width: "100%",
								cursor: "pointer",
							}}
							radius="md"
							bd={
								current && current.id && current.id == item.id
									? "1px solid black"
									: "none"
							}
							alt={`Image ${index}`}
							onClick={() => onSelectAvatar(item)}
							src={item.src}
						/>
					</AspectRatio>
				</Carousel.Slide>
			))}
		</Carousel>
	);
};

export const ImageSelectionGrid = <T extends { id: string, src: string },>({
	size = { base: 50, sm: 60, md: 70, lg: 80 },
	data = [],
	current = null,
	onSelect = () => null,
}: {
	data: T[];
	current: T | null | undefined;
	onSelect: (item: { id: string }) => void;
	size?: { base: number, sm: number, md: number, lg: number };
}) => {
	return (
		<SimpleGrid cols={3} spacing={'5px'}>
			{data.map((item, idx) => (
				<AspectRatio ratio={1} w={size}>
					<Image
						key={idx}
						style={{
							objectFit: "cover",
							cursor: "pointer",
						}}
						radius="md"
						bd={
							current && current.id && current.id == item.id
								? "1px solid black"
								: "none"
						}
						src={item.src}
						onClick={() => onSelect(item)}
					/>

				</AspectRatio>
			))}
		</SimpleGrid>
	);
};
